import { render, staticRenderFns } from "./AnalyzDocumentList.vue?vue&type=template&id=561c70d6&scoped=true"
import script from "./AnalyzDocumentList.vue?vue&type=script&lang=js"
export * from "./AnalyzDocumentList.vue?vue&type=script&lang=js"
import style0 from "./AnalyzDocumentList.vue?vue&type=style&index=0&id=561c70d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c70d6",
  null
  
)

export default component.exports